import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=7b30f288&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=js"
export * from "./ExpiredLink.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=7b30f288&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30f288",
  null
  
)

export default component.exports